import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { MenuItems } from 'app/shared/menu-items/menu-items';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { AuthUser } from '../core/auth-user.model';
import { SignIn } from '../core/auth.actions';
import { AuthState } from '../core/auth.state';

@Injectable()
export class CustomAuthGuard  {
  @Select(AuthState.signedIn) signedIn$: Observable<boolean>;
  @Select(AuthState.user) user$: Observable<AuthUser>;
  @Select(AuthState.inactiveMemberForSubscription) inactiveMemberForSubscription$: Observable<boolean>;
  @Select(AuthState.loading) loadingSignedIn$: Observable<boolean>;

  constructor(
    private store: Store,
    private router: Router,
    private menuItems: MenuItems) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([
      this.signedIn$,
      this.loadingSignedIn$,
      this.user$,
      this.inactiveMemberForSubscription$
    ]).pipe(
      tap(([signedIn, loading, user, inactiveMemberForSubscription]) => {
        if (!signedIn && !loading) {
          this.store.dispatch(new SignIn(state.url));
        }
      }),
      filter(([signedIn, loading, user, inactiveMemberForSubscription]) => !!signedIn && !loading && !!user && inactiveMemberForSubscription!==undefined),
      map(([signedIn, loading, user, inactiveMemberForSubscription]) => {

        const authorized = this.menuItems.hasRoles(next?.routeConfig?.path, user); 
        var isSubscriptionPage = state.url.includes('farp-subscription');  

        if (!authorized) {
          this.router.navigate(['/home']);
        } else {
          if (inactiveMemberForSubscription && !isSubscriptionPage) {
            this.router.navigate(['/farp-subscription/index']);
          }
        }

        return authorized;

      }),
    )
  }
}
